import actionTypes from './action-types';
import initialState from './initial-state';

const initialize = initData => ({
    type: actionTypes.INITIALIZE,
    payload: initialState(initData)
});

// TCF = https://iabeurope.eu/transparency-consent-framework/
const setTcfLoaded = () => {
    return {
        type: actionTypes.SET_TCF_LOADED
    };
};

const setAds = ads => {
    return {
        type: actionTypes.SET_ADS,
        payload: ads
    };
};

export default {
    initialize,
    setAds,
    setTcfLoaded
};
